import { FC } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormRegister,
} from 'react-hook-form';

import type { Condition } from 'types/notification';
import type { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';
import {
  ConditionForm,
  DateRangeForm,
  LevelForm,
  MessageForm,
  TitleForm,
} from 'page/NotificationPage/components/Forms';
import { CustomerList } from '../CustomerList';

type Props = {
  control: Control<NotificationFormFields>;
  formState: FormState<NotificationFormFields>;
  isOpen: boolean;
  shouldShowCostomerList: boolean;
  isButtonDisabled: boolean;
  register: UseFormRegister<NotificationFormFields>;
  getValues: UseFormGetValues<NotificationFormFields>;
  handleClose: () => void;
  handleChangeCondition: (condition: Condition) => void;
  handleClickGoSecond: () => void;
};

export const InputModalView: FC<Props> = ({
  control,
  formState,
  isOpen,
  shouldShowCostomerList,
  isButtonDisabled,
  register,
  getValues,
  handleClose,
  handleChangeCondition,
  handleClickGoSecond,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="6xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent h="90vh">
      <ModalHeader p="40px 40px 0 40px">お知らせ新規作成</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {/* 件名 */}
        <Box mt="40px">
          <TitleForm register={register} error={formState.errors.title} />
        </Box>
        {/* 本文 */}
        <Box mt="40px">
          <MessageForm register={register} error={formState.errors.message} />
        </Box>
        {/* お知らせ種別 */}
        <Box mt="40px">
          <LevelForm register={register} />
        </Box>
        {/* 表示期間 */}
        <Box mt="40px">
          <DateRangeForm
            control={control}
            getValues={getValues}
            startDateError={formState.errors.startDate}
            endDateError={formState.errors.endDate}
          />
        </Box>
        {/* 配信対象顧客 */}
        <Box mt="40px">
          <ConditionForm
            control={control}
            handleChangeCondition={handleChangeCondition}
          />
        </Box>
        {/* 顧客一覧 */}
        <Box mt="40px" mb="40px">
          {shouldShowCostomerList && <CustomerList />}
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <Button
          width="140px"
          colorScheme="blackAlpha"
          mr={3}
          onClick={handleClickGoSecond}
          isDisabled={isButtonDisabled}
        >
          確認
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
